
<script>

import { defineComponent } from 'vue'

import Editor from '@tinymce/tinymce-vue'

/* Default icons are required for TinyMCE 5.3 or above */
import 'tinymce/icons/default';

/* A theme is also required */
import 'tinymce/themes/silver';

/* Import the skin */
import 'tinymce/skins/ui/oxide/skin.css';

/* Import plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';

export default defineComponent({
  name: 'tinyMCEeditor',
	data() {
		return {
      obsah:""
      ,workContent:{}
      ,paddingBottom: 0
			,initObj: {
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:400
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
        ,plugins: 'wordcount, advlist, autolink, link, image, lists, charmap, print, preview, hr, anchor, pagebreak, spellchecker, searchreplace, visualblocks, visualchars, code, fullscreen, insertdatetime, media, nonbreaking, save, table, directionality, emoticons, template, paste'
        ,toolbar: 'undo redo | copy cut paste | formatselect | bold italic underline backcolor forecolor | link image table | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',

			},
		}
	},
  props: {
    'content': Object
  },
  emits: ["changeContent"],
  components: {
    'editor': Editor
  }
  ,mounted () {
    this.obsah = this.content.fields.textEditor;

    if(this.content.fields.paddingBottom){
			this.paddingBottom=this.content.fields.paddingBottom;
		}

    this.workContent = this.content;
  },
  
	methods: {
 
    onChangeContent:function(){
      if(this.content.fields.textEditor !== this.obsah){
        this.workContent.contentWasChanged=true;
      }
      this.workContent.fields.textEditor=this.obsah;
      this.sendContent();
		},

    onChangePaddingBottom:function(){
			this.workContent.fields.paddingBottom=this.paddingBottom;
      this.workContent.contentWasChanged=true;
      this.sendContent();
		},

    sendContent:function(){
			this.workContent.content = JSON.stringify(this.workContent.fields);
			this.$emit('changeContent', this.workContent)
		},
	},
	
	watch: {
    obsah() {
      //if(this.content.fields.textEditor !== this.obsah){
       // e.contentWasChanged=true;
      //  this.$emit('changeContent', this.workContent)
     // }
		}
	},
	
	created() {

	}
  
})
</script>

<template>
  <div>

    <div class="col-12 col-md-4">
      <label><b>{{ $t('msgCore.paddingBottom') }}</b></label><br>
      
      <div v-for="(option) in 5" :key="option" class="form-check-inline">
        <label class="form-check-label">
          <input class="form-check-input" type="radio" :name="`paddingBottom${obsah}`" v-model='paddingBottom' v-on:change="onChangePaddingBottom()" :value="option">
          {{ option }}
          <span class="circle">
            <span class="check"></span>
          </span>
        </label>
      </div>

    </div>

    <div class="col-12">
      <editor tinymce-script-src="tinymce/tinymce.min.js" v-model="obsah" :init="initObj"  @selectionChange="onChangeContent" />
    </div>

  </div>
</template>